import React, { InputHTMLAttributes } from "react";

import { Input, Container } from "./styles";

import searchIcon from "./assets/searchIcon.svg";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const SearchInputBase: React.FC<InputProps> = ({ ...rest }) => {
  return (
    <Container>
      <Input {...rest} />
      <img src={searchIcon} className="search-input" />
    </Container>
  );
};

export default SearchInputBase;
